import React from 'react';
import { QuickAdjustProduct } from '../../types';
import { getAvatarColor, getInitials } from '../../utils';
import * as S from './styles';

type ProductAvatarProps = {
    product: Pick<QuickAdjustProduct, 'name' | 'image_url'>;
    size?: 'small' | 'large';
};

const ProductAvatar = ({ product, size = 'small' }: ProductAvatarProps) => {
    const $large = size === 'large';

    return (
        <S.Avatar
            bg={product.image_url ? '#fff' : getAvatarColor(product.name)}
            $large={$large}
        >
            {product.image_url ? (
                <S.AvatarImage src={product.image_url} alt={product.name} />
            ) : (
                getInitials(product.name)
            )}
        </S.Avatar>
    );
};

export default ProductAvatar;
